import { ThemeType } from '@/finsight/domain/vo/CreditFlow/Articles/themeTypes';

export const ArticlesType = {
  commentary: ThemeType.commentary,
  dealFlow: ThemeType.dealFlow,
};

export const mapArticleTypeToTitle = {
  [ArticlesType.commentary]: 'Commentary',
  [ArticlesType.dealFlow]: 'Deal Flow',
};

export const SEARCH_MIN_LENGTH = 3;
export const SEARCH_MAX_LENGTH = 128;
